import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsCollection, CmsContentType, CmsViewType } from '@fcom/core-api';

@Component({
  selector: 'cms-articles-with-icons',
  templateUrl: './cms-articles-with-icons.component.html',
  styleUrls: ['./cms-articles-with-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsArticlesWithIconsComponent {
  @Input()
  content$: Observable<CmsCollection>;
  protected readonly CmsContentType = CmsContentType;
  protected readonly CmsViewType = CmsViewType;
}
